<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <h5>Raporty 
                    <router-link class="btn btn-circle torre-red" :to="{ name: 'reportsNew' }" title="Dodaj raport">
                        <i class="material-icons" >
                        add
                        </i>
                    </router-link>
                </h5>
            </div>
        </div>
        <table class="table table-hover">
            <thead>
                <tr>
                    <th class="align-top">
                        <div class="input-group-sm align-top mb-2">
                            <label >Raport</label>
                        </div>
                    </th>
                    <th class="align-top">
                        <div class="input-group-sm align-top mb-2">
                            <select @change="reloadContent()" class="form-control" v-model="form.storeId">
                                <option v-for="option in storesOptions" :key="option.id" v-bind:value="option.id">
                                    {{ option.name }}
                                </option>
                            </select>
                        </div>
                    </th>
                    <th class="align-top">
                        <div class="input-group-sm align-top mb-2">
                            <label >Pracownik</label>
                        </div>
                    </th>
                    <th class="align-top">
                        <div class="input-group-sm align-top mb-2">
                            <label >Zakup telefonów</label>
                        </div>
                    </th>
                    <th class="align-top">
                        <div class="input-group-sm align-top mb-2">
                            <label >Sprzedaż telefonów</label>
                        </div>
                    </th>
                    <th class="align-top">
                        <div class="input-group-sm align-top mb-2">
                            <label >Wydatki</label>
                        </div>
                    </th>
                    <th class="align-top">
                        <div class="input-group-sm align-top mb-2">
                            <label >Łącznie sprzedaż</label>
                        </div>
                    </th>
                    <th class="align-top">
                        <div class="input-group-sm align-top mb-2">
                            <label >Edycja</label>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in reports" :key="item.id">
                    <td>Raport {{ formatDate(item.createDate) }}</td>
                    <td>{{ item.storeName }}</td>
                    <td>{{ item.createdBy }}</td>
                    <td>{{ formatPrice(item.boughtPhonesSum) }}</td>
                    <td>{{ formatPrice(item.soldPhonesSum) }}</td>
                    <td>{{ formatPrice(item.expensesSum) }}</td>
                    <td>{{ formatPrice(item.totalIncome) }}</td>
                    <td><router-link :to="{ name: 'reportEdit', params: { id: item.id } }">podgląd</router-link></td>
                </tr>
            </tbody>
        </table>
        <div v-if="showEmptyResult" class="row">
            <div class="col text-center">
                Brak wyników
            </div>
        </div>
        <common-pagination @paginationClicked="onPaginationClicked"/>
    </div>
</template>
<script>
import alertify from 'alertifyjs';
import un from 'underscore'
import ReportsService from "@/components/reports/ReportsService"
import Formatter from "@/service/Formatter"

const formatter = new Formatter()
const reportsService = new ReportsService()

export default {
    name: "ReportsList",
    data: function() {
        return {
            loading: false,
            reports: [],
            storesOptions: [],
            pageable: {
                page: 0
            },
            form: {
                storeId: 0
            }
        }
    },
    computed: {
        showEmptyResult() {
            return this.loading === false && this.reports.length === 0
        }
    },
    created() {
        this.initStoresOptions()
    },
    methods: {
        formatPrice(price) {
            return formatter.price.ZL(price)
        },
        formatDate(reportDate) {
            return formatter.date.YMDHHmm(reportDate)
        },
        initStoresOptions() {
            reportsService.initStores(this.onStoresSuccess)
        },
        onSearchSuccess(data) {
            this.loading = false
            this.reports = data.items
            this.$emit('dataChanged', {
                data: data
            });
        },
        onSearchError(err) {
            this.loading = false
            console.log(err)
        },
        reloadContent() {
            const requestData = {
                params: this.form,
                pageable: this.pageable
            }
            this.loading = true
            reportsService.search(requestData, this.onSearchSuccess, this.onSearchError)
        },
        onStoresSuccess(data, selectedStore) {
            this.storesOptions = this.initStores(data)
            this.form.storeId = selectedStore.id
            this.reloadContent()
        },
        initStores(options) {
            const finalList = []
            // if (reportsService.isAdmin()) {
            //     const defaultOption = {
            //         id: "0",
            //         name: "wszystkie"
            //     }
            //     finalList.push(defaultOption)
            // }
            for (var i in options) {
                var item = options[i]
                finalList.push({
                    id: item.id,
                    name: item.name
                })
            }
            return finalList
        },
        onPaginationClicked(payload) {
            var pageToSend = payload.pageToSend;
            this.pageable.page = pageToSend;
            this.reloadContent();
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/reports/ReportsList.vue